module.exports = __webpack_public_path__ + "static/img/scholarship2.943e7ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/scholarship2.png
// module id = c33/
// module chunks = 1